import React from 'react'

import { Col } from 'components/Layout'
import InfoCard from 'components/Cards/InfoCard'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default ({ title, subtitle = '', children = null, loading = false, style = {} }) => (
  <InfoCard className={cn(sLay['layout-column'], sLay['layout-align-center-center'])} style={style}>
    <div className={cn(sText.descrip1, sText.center)}>{title}</div>
    <p className={cn(sText.descrip3, sText.center)}>{subtitle}</p>
    {children && [
      <br key="break" />,
      <div key="row" className={cn(sLay['layout-row'], sLay['layout-align-center-center'])}>
        {children.map ? (
          children.map((child, idx) => <Col key={idx}>{child}</Col>)
        ) : (
          <Col>{children}</Col>
        )}
      </div>,
    ]}
    {loading && <LoadingOverlay />}
  </InfoCard>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Cards/EmptyMessageCard/EmptyMessageCard.jsx